import React from 'react'
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import List from './list'
import Emtpty from '../empty'


import './list-draggable.styl'
class DraggableList extends React.Component {
    static propTypes = {
        label: PropTypes.string,
        className: PropTypes.string,
        printable: PropTypes.bool,
        collection: PropTypes.array.isRequired,
        onDragStart: PropTypes.func,
        onDrag: PropTypes.func,
        onDragComplete: PropTypes.func,
        onDragUpdate: PropTypes.func
    }

    static defaultProps = {
        onDragComplete: () => {}
    }

    dragStart(e) {
        this.props.onDragStart()

        this.dragged = ReactDOM.findDOMNode(e.currentTarget)
        this.dragged.classList.add("dragging");

        e.dataTransfer.effectAllowed = 'move';
        // Firefox requires dataTransfer collection to be set
        e.dataTransfer.setData("text/html", e.currentTarget);
    }

    dragEnd(e) {
        this.dragged.classList.remove("dragging");
        //update list
        const {collection} = this.props
        let from = Number(this.dragged.dataset.id);
        let to = Number(this.over.dataset.id);
        from < to && to--;
        this.nodePlacement == "after" && to++;
        collection.splice(to, 0, collection.splice(from, 1)[0]);
        this.setState({collection: collection});
        this.props.onDragComplete(collection)
    }

    dragOver(e) {
        e.preventDefault();
        if(e.target.nodeName !== 'LI') {
            return ;
        }
        if(e.target == this.dragged ){
            return;
        }
        this.over = e.target;
        // Inside the dragOver method
        let relY = e.clientY - this.over.offsetTop;
        let height = this.over.offsetHeight / 2;
        let parent = this.dragged.parentNode;
        if(relY >= height) {
            this.nodePlacement = "after";
            parent.removeChild(this.dragged);
            parent.insertBefore(this.dragged, e.target.nextElementSibling);

        } else if(relY <= height) {
            this.nodePlacement = "before"
            parent.removeChild(this.dragged);
            parent.insertBefore(this.dragged, e.target);
        }
    }

    update = ( {printable=true, collection=false}) => {
        if(!printable) return <div className="hide"></div>
        if(!collection) return

        const ul = this.root.getElementsByTagName('ul')[0]
        const liList = this.root.getElementsByTagName('li')
        ul.addEventListener('dragover', this.dragOver.bind(this));
        [...liList].forEach(child => {
            const node = ReactDOM.findDOMNode(child);
            node.setAttribute('draggable', true);
            node.addEventListener('dragstart', this.dragStart.bind(this));
            node.addEventListener('dragend', this.dragEnd.bind(this));
        });
    }

    componentDidUpdate = (prevProps, prevState, snapshot) => this.update(this.props)

    componentDidMount = () => this.update(this.props)

    render() {
        const {label='', collection} = this.props;
        let {className} = this.props;

        if(!collection || !collection.length) {
            return <Emtpty printable={true}/>
        }

        className = 'form draggable-list' + (className ? ' ' + className : '')
        return React.createElement(List, {label, className, collection, ref: node => this.root = ReactDOM.findDOMNode(node) })
    }
}

export default DraggableList;
